export default __webpack_public_path__ + "static/mouse_app-0a6437512bdc6ac261f117a9f7bce034.svg";